import React from 'react';
import propTypes from 'prop-types';
import cx from 'classnames';
import './_button.scss';

const Button = props => {
    const { label, primary, isRounded, className, ...rest } = props;

    const classes = cx(
        className && className,
        'c-btn',
        primary && 'c-btn--primary',
        isRounded && 'c-btn--rounded',
    );

    return (
        <button className={classes} type="button" {...rest}>{label}</button>
    );
};

Button.propTypes = {
    label: propTypes.node.isRequired,
    primary: propTypes.bool,
    isRounded: propTypes.bool,
    className: propTypes.string,
};

Button.defaultProps = {
    primary: false,
    isRounded: false,
};

export default Button;

